import React from 'react';
import { hasTimedOut } from '../../services/teacher/recentTeacherSelections';
export default class Tabs extends React.Component {
  constructor (props){
    super(props);

    this.state = {
      selectedTab: this.props.defaultTab || 0,
    };
  }

  onTabClick(tabId){
    this.setState({
      selectedTab: tabId,
    });

    // report tab changed to parent component
    if(this.props.reportTabChange){
      this.props.reportTabChange(tabId)
    }
  }

  getTabs(){
    let tabs = [];
    let content = [];
    for(let i = 0; i < this.props.tabs.length; i++){
      let tabContent = this.props.tabs[i];
      let className = "tab";
      let contentClassName = "tabContent";
      let onClick = this.onTabClick.bind(this, i);
      if(i == this.state.selectedTab){
        className += " selected";
        contentClassName += " display";
      }
      if(this.props.scrollable){
        contentClassName += " scrollable";
      }
      if(!tabContent.content){
        className += " disabled";
        onClick = null;
      }
      tabContent.content && content.push(
        <div className={contentClassName} key={"content" + i}>
          <div className="printTitle">{tabContent.tab}</div>
          {tabContent.content}
        </div>
      );
      tabs.push(
        <div className={className} key={"tab" + i} onClick={onClick}>
          {tabContent.tab}
        </div>
      );
    }
    return({
      tabs: tabs,
      content: content,
    });
  }


  render() {
    let tabs = this.getTabs();
    return (
      <div className="tabs">
        <div className="tabHeader">
          {tabs.tabs}
        </div>
        {tabs.content}
      </div>
    );
  }
}

